import { z } from "zod";

import { eventSchema } from "../shared";

// Analysis Process Events
export const resumeAnalysisStartedEvent = eventSchema.extend({
  event: z.string().default("resume_analysis_started"),
  properties: z.object({
    resumeId: z.string().optional(),
    hasJobDescription: z.boolean(),
    metricsCount: z.number(),
  }),
});

export const resumeAnalysisCompletedEvent = eventSchema.extend({
  event: z.string().default("resume_analysis_completed"),
  properties: z.object({
    resumeId: z.string().optional(),
    success: z.boolean(),
    overallScore: z.number().optional(),
    totalMetrics: z.number(),
    successfulMetrics: z.number(),
    failedMetrics: z.number(),
    processingTime: z.number(),
    errorMessage: z.string().optional(),
  }),
});

export const resumeAnalysisMetricCalculatedEvent = eventSchema.extend({
  event: z.string().default("resume_analysis_metric_calculated"),
  properties: z.object({
    metric: z.string(),
    executionTime: z.number(),
  }),
});

export const resumeAnalysisMetricFailedEvent = eventSchema.extend({
  event: z.string().default("resume_analysis_metric_failed"),
  properties: z.object({
    metric: z.string(),
    attempt: z.number(),
    maxAttempts: z.number(),
    errorMessage: z.string(),
    finalFailure: z.boolean(),
  }),
});

// Analysis Storage Events
export const resumeAnalysisStoredEvent = eventSchema.extend({
  event: z.string().default("resume_analysis_stored"),
  properties: z.object({
    resumeId: z.string(),
    overallScore: z.number(),
    analysisId: z.string(),
  }),
});

// Analysis Retrieval Events
export const resumeAnalysisRetrievedEvent = eventSchema.extend({
  event: z.string().default("resume_analysis_retrieved"),
  properties: z.object({
    resumeId: z.string(),
    analysisId: z.string(),
    overallScore: z.number(),
    isLatest: z.boolean(),
  }),
});

export const resumeAnalysisGeneratedEvent = eventSchema.extend({
  event: z.string().default("resume_analysis_generated"),
  properties: z.object({
    resumeId: z.string(),
    hasJobDescription: z.boolean(),
    triggeredBy: z.enum(["user_request", "optimization_process", "system"]),
  }),
});

// Type exports
export type ResumeAnalysisStartedEvent = z.infer<typeof resumeAnalysisStartedEvent>;
export type ResumeAnalysisCompletedEvent = z.infer<typeof resumeAnalysisCompletedEvent>;
export type ResumeAnalysisMetricCalculatedEvent = z.infer<
  typeof resumeAnalysisMetricCalculatedEvent
>;
export type ResumeAnalysisMetricFailedEvent = z.infer<typeof resumeAnalysisMetricFailedEvent>;
export type ResumeAnalysisStoredEvent = z.infer<typeof resumeAnalysisStoredEvent>;
export type ResumeAnalysisRetrievedEvent = z.infer<typeof resumeAnalysisRetrievedEvent>;
export type ResumeAnalysisGeneratedEvent = z.infer<typeof resumeAnalysisGeneratedEvent>;
